<script lang="ts" setup>
  import { useForwardPropsEmits, type AccordionRootEmits, type AccordionRootProps } from 'radix-vue'
  import { provide } from 'vue'

  const props = defineProps<AccordionRootProps>()
  const emits = defineEmits<AccordionRootEmits>()

  const forwarded = useForwardPropsEmits(props, emits)

  const value = computed(() => props.modelValue)

  provide('accordionValue', value)
</script>

<template>
  <AccordionRoot v-bind="forwarded">
    <slot />
  </AccordionRoot>
</template>
